var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-card",
    {
      staticClass: "app-card pa-4",
      attrs: {
        text: "",
        height: "100%"
      }
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "justify-center pt-0"
        },
        [_c("h2", [_vm._v("Site Seal")])]
      ),
      _c(
        "v-card-text",
        {
          staticClass: "text-center"
        },
        [
          _c("img", {
            staticClass: "image--centered",
            attrs: {
              src: "/static/img/amui/siteseal.png",
              width: "100",
              heigth: "55",
              alt: "Site Seal"
            }
          }),
          _c(
            "p",
            {
              staticClass: "text-center pt-4 mb-0"
            },
            [
              _vm._v(
                " Install your GlobalSign SSL Certificate Secure Site Seal by clicking on the button below. "
              )
            ]
          )
        ]
      ),
      _c(
        "v-card-actions",
        {
          staticClass: "pt-4 pb-0"
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center"
                },
                [
                  _c(
                    "gg-btn",
                    {
                      staticClass: "justify-center",
                      on: {
                        click: function click($event) {
                          _vm.dialog = true
                        }
                      }
                    },
                    [_vm._v("Install Site Seal")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("install-site-seal", {
        attrs: {
          modal: _vm.dialog
        },
        on: {
          close: function close($event) {
            _vm.dialog = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }